import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLinkCard } from './ExternalLinkCard';

import classes from './ExternalLinks.module.scss';

export interface ConfigExternalLink {
  url: string;
  headline: string;
  description?: string;
  image?: string;
}

export interface ConfigExternalLinksWidget {
  titleLocaliseKey?: string;
  links: ConfigExternalLink[];
}

interface ExternalLinksProps {
  config: ConfigExternalLinksWidget;
}

export const ExternalLinks: FunctionComponent<ExternalLinksProps> = ({ config }) => {
  const { t } = useTranslation();

  const { titleLocaliseKey, links } = config;

  if (!links.length) {
    return null;
  }

  return (
    <div className={classes['external-links']}>
      {titleLocaliseKey && (
        <h2 className={classes['external-links__title']}>{t(titleLocaliseKey)}</h2>
      )}
      {links.map((link) => (
        <ExternalLinkCard key={link.url} {...link} />
      ))}
    </div>
  );
};
